import React from 'react';
import { Element } from '@design-systems/utils';
import makeClass from 'clsx';

import styles from './Backdrop.css';

interface BackdropProps extends Element<'div'> {
  /**
   * Determines whether to load the backdrop or not
   */
  open: boolean;
  /**
   * The value for the Backdrop's z-index
   */
  zIndex?: number;
  /**
   * Determines the background color of the backdrop
   */
  light: boolean;
}

/** A partially see-through backdrop to overlay components on. Such as a modal. */
const Backdrop = (props: BackdropProps) => {
  const { open, zIndex, light, className, style, ...html } = props;
  const mounted = React.useRef<boolean>();

  React.useEffect(() => {
    if (open && !mounted.current) {
      mounted.current = true;
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = open ? 'hidden' : 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  });

  if (!open) {
    return null;
  }

  const classNames = makeClass(
    className,
    light ? styles.wrapperLight : styles.wrapperDark
  );
  const elementStyles = { ...style, zIndex };

  return (
    <div {...html} tabIndex={-1} style={elementStyles} className={classNames} />
  );
};

Backdrop.defaultProps = {
  open: false,
  light: false
};

export default Backdrop;
